import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetDefaultCameraTemplateForMattressInspectorQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetDefaultCameraTemplateForMattressInspectorQuery = { __typename: 'Query', template: { __typename: 'Template', id: string, latestRevision?: { __typename: 'TemplateRevision', id: string, graph?: any | null } | null } };

export type GetTemplateLegacyIdsForMattressInspectorQueryVariables = Types.Exact<{
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type GetTemplateLegacyIdsForMattressInspectorQuery = { __typename: 'Query', templates: Array<{ __typename: 'Template', id: string, legacyId: number } | null> };

export type GetMaterialLegacyIdsForMattressInspectorQueryVariables = Types.Exact<{
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type GetMaterialLegacyIdsForMattressInspectorQuery = { __typename: 'Query', materials: Array<{ __typename: 'Material', id: string, legacyId: number } | null> };

export const GetDefaultCameraTemplateForMattressInspectorDocument = gql`
    query getDefaultCameraTemplateForMattressInspector($id: ID!) {
  template(id: $id) {
    id
    latestRevision {
      id
      graph
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDefaultCameraTemplateForMattressInspectorGQL extends Apollo.Query<GetDefaultCameraTemplateForMattressInspectorQuery, GetDefaultCameraTemplateForMattressInspectorQueryVariables> {
    override document = GetDefaultCameraTemplateForMattressInspectorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTemplateLegacyIdsForMattressInspectorDocument = gql`
    query getTemplateLegacyIdsForMattressInspector($ids: [ID!]) {
  templates(filter: {id: {in: $ids}}, take: 10000) {
    id
    legacyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemplateLegacyIdsForMattressInspectorGQL extends Apollo.Query<GetTemplateLegacyIdsForMattressInspectorQuery, GetTemplateLegacyIdsForMattressInspectorQueryVariables> {
    override document = GetTemplateLegacyIdsForMattressInspectorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMaterialLegacyIdsForMattressInspectorDocument = gql`
    query getMaterialLegacyIdsForMattressInspector($ids: [ID!]) {
  materials(filter: {id: {in: $ids}}, take: 10000) {
    id
    legacyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaterialLegacyIdsForMattressInspectorGQL extends Apollo.Query<GetMaterialLegacyIdsForMattressInspectorQuery, GetMaterialLegacyIdsForMattressInspectorQueryVariables> {
    override document = GetMaterialLegacyIdsForMattressInspectorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }